import { render, staticRenderFns } from "./BigBuyImport.vue?vue&type=template&id=3ee7399f&scoped=true"
import script from "./BigBuyImport.vue?vue&type=script&lang=js"
export * from "./BigBuyImport.vue?vue&type=script&lang=js"
import style0 from "./BigBuyImport.vue?vue&type=style&index=0&id=3ee7399f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7399f",
  null
  
)

export default component.exports